<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import SubNavMessageDashIcon from '$icons/SubNavMessageDashIcon.svelte';
  import SubNavInfoCircleIcon from '$icons/SubNavInfoCircleIcon.svelte';
  import SubNavProfileCircleIcon from '$icons/SubNavProfileCircleIcon.svelte';
  import SubNavLogoutIcon from '$icons/SubNavLogoutIcon.svelte';
  import SubNavAdminSettingsIcon from '$icons/SubNavAdminSettingsIcon.svelte';
    import Document from '$lib/icons/iconsax/outline/Document.svelte';

  export let title: profileNavItems = ' ';

  let container: HTMLElement;

  const dispatch = createEventDispatcher();
</script>

<button
  bind:this={container}
  class="flex w-full justify-center  px-4 py-2  my-4 border rounded-full cursor-pointer md:justify-start lg:p-2 lg:rounded-xl lg:border-none shadow-sidebar-item lg:shadow-none hover:text-garden-grey-600 {title ===
  'Logout'
    ? 'hover:bg-red-200'
    : 'hover:bg-gray-300 hover:bg-opacity-30'}"
  on:click={() => dispatch('MenuItemClick', { tab: title, container: container })}
>
  <div class="flex items-center justify-center w-6 h-6">
    {#if title === 'My profile'}
      <SubNavProfileCircleIcon />
    {/if}

    {#if title === 'Admin settings'}
      <SubNavAdminSettingsIcon />
    {/if}

    {#if title === 'Help and support'}
      <SubNavMessageDashIcon />
    {/if}

    {#if title === 'F.A.Q'}
      <SubNavInfoCircleIcon />
    {/if}

    {#if title === 'About'}
      <Document />
    {/if}

    {#if title === 'Logout'}
      <SubNavLogoutIcon />
    {/if}
  </div>
  <span class={`pl-1 ${$$props.class} ${title === 'Logout' ? 'text-accent-red-50' : 'text-garden-grey-600'}`}>
    {title}
  </span>
</button>
